import ActionType from "../../types/ActionType"
import { TimelineApiItem } from "../../types/TimelineType"
import TimelinePersonActions from "../actions/timelinePerson"

export interface TimelinePersonStore {
  errorMessage: string
  loadingTimelinePerson: boolean
  timelineItems: TimelineApiItem[]
  nextTimelineCursor?: string
  timelinePages: TimelineApiItem[][]
  timelineNextCursors: Array<string | undefined>
  timelinePersonOrganizationRoleProgramId?: string
}

const INITIAL_STATE: TimelinePersonStore = {
  errorMessage: "",
  loadingTimelinePerson: false,
  timelineItems: [],
  nextTimelineCursor: undefined,
  timelinePages: [],
  timelineNextCursors: [],
  timelinePersonOrganizationRoleProgramId: undefined,
}

export default (state = INITIAL_STATE, action: ActionType) => {
  switch (action.type) {
    case TimelinePersonActions.FETCH_TIMELINE_PERSON_TRIGGER: {
      return {
        ...state,
        loadingTimelinePerson: true,
      }
    }

    case TimelinePersonActions.FETCH_TIMELINE_PERSON_SUCCESS: {
      const incomingItems: TimelineApiItem[] = action.payload.items || []
      const currentItems: TimelineApiItem[] = state.timelineItems || []
      const appendItems = !!action.payload.append
      const timelinePages = appendItems ? [...state.timelinePages, incomingItems] : [incomingItems]
      const timelineNextCursors = appendItems ? [...state.timelineNextCursors, action.payload.nextCursor] : [action.payload.nextCursor]
      const timelineItems = appendItems ? [...currentItems, ...incomingItems].filter((item, index, arr) => arr.findIndex((candidate) => candidate.id === item.id) === index) : incomingItems

      return {
        ...state,
        loadingTimelinePerson: false,
        timelineItems,
        nextTimelineCursor: action.payload.nextCursor,
        timelinePages,
        timelineNextCursors,
        timelinePersonOrganizationRoleProgramId: action.payload.personOrganizationRoleProgramId,
      }
    }

    case TimelinePersonActions.FETCH_TIMELINE_PERSON_ERROR: {
      return {
        ...state,
        loadingTimelinePerson: false,
        errorMessage: action.payload,
      }
    }

    case TimelinePersonActions.CLEAR_TIMELINE_PERSON: {
      return INITIAL_STATE
    }

    default:
      return state
  }
}
